import { SITE } from "../data/site";

export default function Footer() {
  return (
    <footer
      data-testid="site-footer"
      className="relative mt-24 md:mt-40 border-t border-white/10 py-12"
    >
      <div className="max-w-7xl mx-auto px-6 md:px-12 flex flex-col md:flex-row md:items-end md:justify-between gap-8">
        <div>
          <div className="font-display text-3xl md:text-5xl uppercase tracking-tight">
            {SITE.name}
            <span className="text-[#f5e6d3]">.</span>
          </div>
          <div className="font-editorial italic text-zinc-500 mt-2">
            {SITE.role} — {SITE.location}
          </div>
        </div>

        <div className="grid grid-cols-2 sm:grid-cols-3 gap-6 font-body text-sm">
          <a
            href={`mailto:${SITE.email}`}
            data-testid="footer-email"
            className="text-zinc-400 hover:text-[#f5e6d3] transition-colors"
          >
            {SITE.email}
          </a>
          <a
            href={SITE.whatsappLink}
            target="_blank"
            rel="noopener noreferrer"
            data-testid="footer-whatsapp"
            className="text-zinc-400 hover:text-[#f5e6d3] transition-colors"
          >
            WhatsApp
          </a>
          <a
            href={SITE.linkedin}
            target="_blank"
            rel="noopener noreferrer"
            data-testid="footer-linkedin"
            className="text-zinc-400 hover:text-[#f5e6d3] transition-colors"
          >
            LinkedIn
          </a>
        </div>
      </div>

      <div className="max-w-7xl mx-auto px-6 md:px-12 mt-10 flex flex-col sm:flex-row items-start sm:items-center justify-between gap-3 text-xs font-body text-zinc-600 uppercase tracking-widest">
        <div>© {new Date().getFullYear()} {SITE.name}. All rights reserved.</div>
        <div className="font-editorial italic normal-case tracking-normal">
          Designed & built in Sweden.
        </div>
      </div>
    </footer>
  );
}
